// ── imports explicites (C4 — générés par esm-codemod --analyze, maintenus à la main) ──
import { LANAC_VAPID_PUBLIC, urlBase64ToUint8Array, useEffect, useRef, useState } from "../00-boot.jsx";
import { genId, notifAutoI18n, tx } from "../04-i18n-dict.jsx";
import { alerteFromDB, richNoticeFromRow, rpcGetEmailsEnabled, rpcPushAdminNotification, rpcPushNotification } from "../07-trust-moderation.jsx";
import { lanacSupabaseClient, lanacWrite } from "../08-supabase-client.jsx";
import { SUPPORTED_LOCALES } from "../i18n/loader.jsx";
// ── Tranche 4a · useNotifications : cloche, alertes, HUD toast, interrupteur emails ─
//    Déclarations d'état SEULEMENT : les effets (hydratation, RPC) appellent des
//    helpers d'App — ils migreront avec eux (règle : ne bouge que le possédé).
//    V2-2 : les effets d'hydratation au login (DB + miroirs localStorage) ont
//    MIGRÉ ici avec `me` en paramètre — ils n'utilisent que des imports, `me`
//    et leurs propres setters (corps copiés tels quels, ordre relatif préservé).
/** @param {any} me @param {{lang?:string}} [ports] — `lang` vient de useUiPrefs, appelé AVANT ce hook. */
function useNotifications(me, ports={}){
  const {lang}=ports;
  // BLOC1-3 · Web Push : abonnement branché sur le réglage notifications (me.notifPush).
  // Permission demandée au plus une fois/appareil. Corps déplacé VERBATIM depuis App().
  useEffect(()=>{
    if(typeof navigator==="undefined"||!("serviceWorker" in navigator)||typeof window==="undefined"||!("PushManager" in window)||!me?.id) return;
    let cancelled=false;
    (async()=>{
      try{
        const reg=await navigator.serviceWorker.ready;
        if(cancelled||!reg||!reg.pushManager) return;
        const client=lanacSupabaseClient();
        const existing=await reg.pushManager.getSubscription();
        if(me.notifPush===false){
          if(existing){ const ep=existing.endpoint; try{await existing.unsubscribe();}catch(_){}
            //  (30/10/2026, lot D · la sentinelle) par lanacWrite : un refus se DIT (write_failed), la ligne peut ne pas exister (expect any)
            if(client) lanacWrite({what:"abonnement push retiré",table:"push_subscriptions",op:"delete",match:{user_id:me.id,endpoint:ep},columns:"endpoint",expect:"any",quiet:["offline"]}); }
          return;
        }
        if(typeof Notification==="undefined") return;
        let perm=Notification.permission;
        if(perm==="default"){
          const askedKey=`lanac:pushAsked:${me.id}`;
          try{ if(localStorage.getItem(askedKey)) return; localStorage.setItem(askedKey,"1"); }catch(_){}
          perm=await Notification.requestPermission().catch(()=>"default");
        }
        if(cancelled||perm!=="granted") return;
        const sub=existing||await reg.pushManager.subscribe({userVisibleOnly:true,applicationServerKey:urlBase64ToUint8Array(LANAC_VAPID_PUBLIC)});
        if(cancelled||!sub||!client) return;
        const j=sub.toJSON();
        if(j&&j.endpoint&&j.keys&&j.keys.p256dh&&j.keys.auth){
          //  (30/10/2026, lot D · la sentinelle) par lanacWrite : l'« upsert » avalait son erreur — un refus (42501 depuis D4a si une colonne
          //   hors liste partait) privait le membre de tout avis push sans que personne le sache ; il se DIT désormais (write_failed).
          lanacWrite({what:"abonnement push",table:"push_subscriptions",op:"upsert",values:{user_id:me.id,endpoint:j.endpoint,p256dh:j.keys.p256dh,auth:j.keys.auth,lang,user_agent:(navigator.userAgent||"").slice(0,300)},onConflict:"user_id,endpoint",columns:"endpoint",expect:"one"});
        }
      }catch(_){}
    })();
    return ()=>{ cancelled=true; };
  },[me?.id, me?.notifPush, lang, me?.gen]);
  const [notif,setNotif]=useState(null);
  const [mot,setMot]=useState(null);   // (08/10) le petit mot du haut (LncMot) : {id, texte, ton, action} — voir `direUnMot` dans App
  const [emailsEnabled,setEmailsEnabled]=useState(false); // interrupteur maître emails métier (RPC SECURITY DEFINER)
  // BLOC1-1 · Lecture de l'interrupteur (admin seulement). `isAdmin` était le
  // bloqueur : plutôt que de déménager une valeur dérivée utilisée 16× dans
  // App(), le hook la RECALCULE depuis `me` — le bloqueur disparaît sans qu'un
  // seul symbole ne bouge.
  const isAdminHere=me?.role==="Admin";
  useEffect(()=>{
    if(!isAdminHere) return;
    const client=lanacSupabaseClient();
    if(!client) return;
    let cancelled=false;
    try{const q=rpcGetEmailsEnabled();q&&q.then&&q.then(({data})=>{if(!cancelled)setEmailsEnabled(!!data);},()=>{});}catch(_){} // NOTIF-RPC-1 : passerelle
    return ()=>{cancelled=true;};
  },[isAdminHere]);
  const [notices,setNotices]=useState([]);
  const [noticesHasMore,setNoticesHasMore]=useState(false); // pagination cloche : une page de plus existe en base
  const [noticesSeenAt,setNoticesSeenAt]=useState(0); // horodatage "notifs vues" (dot dock découplé du read par-ligne)
  const [alerts,setAlertsBrut]=useState([]);
  //  (13/10, A40) chaque écriture LOCALE des alertes (pause, vu, suppression, restauration, création) avance ce compteur : une lecture
  //  partie AVANT l'écriture et revenue APRÈS est jetée (elle remettrait l'état d'avant — une alerte supprimée ressuscitée, une pause défaite)
  const alertesGenRef=useRef(0);
  const setAlerts=f=>{ alertesGenRef.current+=1; setAlertsBrut(f); };
  const [noticeFilter,setNoticeFilter]=useState("all");
  const [firstRunNotice,setFirstRunNotice]=useState(false);
  // Notifs "vues" : hydrate par utilisateur (le dot dock ne dépend pas du read par-ligne)
  useEffect(()=>{ if(!me?.id) return; try{ setNoticesSeenAt(Number(localStorage.getItem("lanac:noticesSeenAt:"+me.id))||0); }catch{} },[me?.id]);
  // Phase 5C — load alerts from Supabase (user-specific, overwrites localStorage)
  //  (13/10, A40) la même lecture, RECHARGEABLE : la feuille « Mes alertes » la redemande en s'ouvrant (le compteur de nouveautés et la
  //  pause vivent dans la base), au plus une fois par demi-minute — une feuille rouverte dix fois ne relit pas dix fois. Toujours
  //  bornée : RLS = mes alertes, plafond 100 (A5).
  const alertesLuesRef=useRef(0);
  const rechargerAlertes=(force=false)=>{
    const client=lanacSupabaseClient();
    if(!client||!me?.id) return Promise.resolve(false);
    if(!force&&Date.now()-alertesLuesRef.current<30000) return Promise.resolve(false);
    alertesLuesRef.current=Date.now();
    const gen=alertesGenRef.current;
    return client.from("alerts").select("*").order("ts",{ascending:false}).limit(100).then(({data,error})=>{
      if(alertesGenRef.current!==gen) return false; // une écriture locale est passée pendant le vol : cette lecture est dépassée
      if(!error&&Array.isArray(data)){ setAlertsBrut(data.map(alerteFromDB).filter(Boolean)); return true; }
      return false;
    });
  };
  useEffect(()=>{ alertesLuesRef.current=0; rechargerAlertes(true); },[me?.id,me?.gen]);
  useEffect(()=>{if(!me)return;try{setAlertsBrut(JSON.parse(localStorage.getItem(`lanac:alerts:${me.id}`)||"[]"));}catch{setAlertsBrut([]);}},[me?.id]);
  useEffect(()=>{if(me)try{localStorage.setItem(`lanac:alerts:${me.id}`,JSON.stringify(alerts));}catch(e){}},[alerts,me?.id]); // try/catch 28/08 : quota plein ⇒ pas d'écran d'erreur persistant
  // ═══ L'API DE NOTIFICATION (déplacée VERBATIM depuis App(), 16/07/2026) ═══
  //  Elle vivait dans App() par accident d'histoire ; son propriétaire est ICI
  //  (c'est ce hook qui détient notices/setNotices). Mesure qui a tranché :
  //  pushNotice 81 usages dans App, nL 47, pushMyNotice 26 → ce n'est pas une
  //  dépendance d'un flux, c'est l'API de notification de l'application.
  //
  //  `isAdmin` est REDÉRIVÉ ici depuis notre propre `me` (fonction pure,
  //  identique à App():isAdmin) — aucun état dupliqué, aucune divergence possible.
  //  `pickL` et `pushBrowserNotification` restent INTERNES (0 usage hors bloc).
  //  (`nT`, déplacé verbatim puis prouvé mort — 1 occurrence = sa déclaration —,
  //  a été supprimé au nettoyage du 16/07/2026.)
  const isAdmin=me?.role==="Admin";
  const pushBrowserNotification=(title,text,audience)=>{
    if(audience!=="admin"||!isAdmin||me?.notifPush===false||typeof window==="undefined"||!("Notification" in window)) return;
    const fire=()=>{try{new Notification(title,{body:text,tag:"lanac-admin-review"});}catch{}};
    if(Notification.permission==="granted") fire();
    else if(Notification.permission==="default") Notification.requestPermission().then(p=>p==="granted"&&fire()).catch(()=>{});
  };
  // ── Notifications i18n ─────────────────────────────────────────────────────
  //   title/text d'une notif peuvent être : une chaîne (déjà localisée, repli) OU un
  //   objet multilingue {fr,en,de,pt}. Rendu dans la langue du DESTINATAIRE à l'affichage
  //   (sa langue n'est connue que sur SON appareil → on ne stocke jamais un texte pré-traduit seul).
  const pickL=(v,l)=>{ if(v==null) return ""; if(typeof v==="string") return v; if(typeof v==="object"&&(v.fr!=null||v.en!=null||v.de!=null||v.pt!=null)) return v[l]||v.fr||v.en||v.de||v.pt||""; return String(v); };
  // ⭐ Phase 3 (19/07) · nK = composition de notification PAR CLÉ.
  //   Remplace l'ancien nL(fr,en,de,pt) (composition inline hardcodée sur 4 langues) —
  //   codemod tools/i18n-notif-codemod.mjs, 47 sites → 38 clés T.notif.*.
  //   Construit l'objet multilingue {loc:texte} sur les locales CHARGÉES
  //   (SUPPORTED_LOCALES) en rendant tx(key,loc) + interpolation {pN} des params.
  //   Format de transport IDENTIQUE à nL (objet multilingue) ⇒ RPC/DB/send-push/
  //   localizeNotice/notices déjà stockées INCHANGÉS. Bénéfice : une langue
  //   précachée en plus entre AUTOMATIQUEMENT dans les notifications (0 code).
  //   Interpolation sûre : remplacement littéral {pN}→params[pN] (aucun eval) ;
  //   placeholder laissé intact si le param manque.
  const nInterp=(s,params)=>params?String(s).replace(/\{(\w+)\}/g,(m,k)=>k in params?String(params[k]):m):s;
  const nK=(key,params)=>{ const o={}; for(const l of SUPPORTED_LOCALES){ o[l]=nInterp(tx(key,l),params); } return o.fr!=null?o:{fr:key}; };
  const localizeNotice=(n,l)=>({...n,title:pickL(n.titleI18n!==undefined?n.titleI18n:n.title,l),text:pickL(n.textI18n!==undefined?n.textI18n:n.text,l)});
  const pushNotice=(title,text,color="var(--color-success)",target=null,audience="all",type="generic",dedupKey=null)=>{
    const cid="n"+genId();
    // i18n auto : si le titre/texte correspond à une traduction connue, on stocke les 4 langues
    // (rendu dans la langue du destinataire). Sinon, repli sur la chaîne fournie.
    title=notifAutoI18n(title); text=notifAutoI18n(text);
    const locT=pickL(title,lang), locX=pickL(text,lang);
    setNotices(p=>[{id:cid,title:locT,text:locX,titleI18n:title,textI18n:text,color,target,audience,read:false,ts:Date.now()},...p].slice(0,200));
    pushBrowserNotification(locT,locX,audience);
    // Taxonomie centralisée : si l'appelant n'a pas donné de type, on en dérive un type sémantique
    // à partir de la destination (observabilité + gating futur). Les types explicites passés par
    // l'appelant (new_message, reservation_accepted, review_reminder, transaction_to_confirm, ...)
    // sont PRÉSERVÉS. Métadonnée serveur uniquement : aucun de ces types dérivés n'est dans les
    // listes optional/email (notif_is_optional / enqueue_notification_email) => comportement inchangé.
    if(type==="generic"&&target&&target.view){
      const _v=target.view;
      // ⭐ TYPE SCELLÉ (31/08) : la dérivation `admin` → admin_alert est CONSERVÉE À DESSEIN — la
      //  porte serveur (notif_should_send) AVALE ce type (migration 20260831150000), donc les échos
      //  d'actions admin restants (blocage, contrôle, forfait…) restent LOCAUX et ne persistent plus.
      //  La retirer les ferait fuir en `generic` PERSISTÉ (badge actif) = régression inverse.
      //  Producteurs incidents/signalement retirés (arbitrage aboli 30/08 ; la file = la surface).
      type = _v==="admin"     ? "admin_alert"
           : _v==="review"    ? "review_invite"
           : _v==="messages"  ? "flow_event"
           : _v==="favorites" ? "favorite"
           : _v==="mine"      ? "listing_self"
           : _v==="market"    ? "listing_event"
           : "generic";
    }
    // Persistance + livraison inter-utilisateurs via RPC SECURITY DEFINER (best-effort, ne casse jamais un flux)
    try{
      const _c=lanacSupabaseClient();
      if(_c&&me?.id){
        const payload={title,text,color,target};
        let q;
        if(audience==="admin") q=rpcPushAdminNotification(type,payload,cid); // NOTIF-RPC-1 : passerelle (dedup serveur)
        else q=rpcPushNotification((audience&&audience!=="all")?audience:me.id,type,payload,dedupKey||cid); // NOTIF-RPC-1 : passerelle (dedup serveur)
        if(q&&typeof q.then==="function") q.then(undefined,()=>{});
      }
    }catch(_){}
  };
  const pushMyNotice=(title,text,color="var(--color-success)",target=null,type="generic",dedupKey=null)=>pushNotice(title,text,color,target,me?.id||"all",type,dedupKey);
  // ── C1 (17/07/2026) — fonctions de NOTIFICATIONS remontées de App(), verbatim.
  //  Mesuré : fermetures ~0, hooks[useNotifications] seul ⇒ zéro port. Filets : S7/S8.
  // ⭐ `notifyMessageRecipient` SUPPRIMÉ (31/08) — la jambe était DOUBLEMENT morte :
  //  · le serveur est l'unique producteur de `new_message` (trigger notify_message_insert ;
  //    push_notification refuse la voie client : `if p_type='new_message' and v_actor<>p_user_id
  //    then return null` — chaque appel était un aller-retour RPC jeté à l'arrivée) ;
  //  · son câblage `onMessageSent` n'était même plus APPELÉ par le Messenger (destructuré,
  //    jamais invoqué — vérifié le 31/08). Le destinataire reçoit sa notification par le
  //    canal serveur, strictement comme avant.
  // Pagination cloche : page suivante (25) UNIQUEMENT sur tap « Voir plus » (keyset sur ts bigint —
  // jamais de curseur flottant). Dédup par id, borne mémoire 200.
  const loadMoreNoticesBusyRef=useRef(false);
  const loadMoreNotices=()=>{
    if(loadMoreNoticesBusyRef.current) return;
    const _c=lanacSupabaseClient(); if(!_c||!me?.id) return;
    const oldest=notices.reduce((m,n)=>Math.min(m,Number(n.ts)||m),Infinity);
    if(!Number.isFinite(oldest)){setNoticesHasMore(false);return;}
    loadMoreNoticesBusyRef.current=true;
    _c.from("notifications").select("*").eq("user_id",me.id).lt("ts",oldest).order("ts",{ascending:false}).limit(25).then(({data,error})=>{
      loadMoreNoticesBusyRef.current=false;
      if(error||!Array.isArray(data)){return;}
      setNoticesHasMore(data.length===25);
      if(data.length) setNotices(p=>{
        const seen=new Set(p.map(n=>n.id));
        const toNoticeRow=row=>({ id:row.id, type:row.type, titleI18n:row.payload?.title??"", textI18n:row.payload?.text??"",
          color:row.payload?.color||"var(--color-success)", target:row.payload?.target||null,
          audience:me.id, read:!!row.read, ts:Number(row.ts)||0, riche:richNoticeFromRow(row) });
        return [...p,...data.filter(r=>!seen.has(r.id)).map(toNoticeRow)].slice(0,200);
      });
    },()=>{loadMoreNoticesBusyRef.current=false;});
  };
  // 12/07 · Regroupement d'AFFICHAGE (anti-bruit, zéro requête) : les notices d'engagement
  // identiques (même type + même titre + même annonce + même jour) fusionnent en UNE ligne
  // avec pastille « ×N » ; clic = tout marquer lu + ouvrir la cible. Le transactionnel
  // (messages, réservations, avis, comptes, flux) n'est JAMAIS regroupé : une ligne chacun.
  const NOTICE_GROUPABLE=new Set(["favorite","listing_event","listing_self","review_invite","generic"]);
  const groupNoticesForDisplay=list=>{
    const out=[],byKey=new Map();
    for(const n of list){
      const t=n.type||"generic";
      if(!NOTICE_GROUPABLE.has(t)){out.push(n);continue;}
      const key=t+"|"+(n.title||"")+"|"+String(n.target?.itemId??"")+"|"+new Date(Number(n.ts)||0).toDateString();
      const g=byKey.get(key);
      if(!g){const item={...n,groupIds:[n.id],groupCount:1};byKey.set(key,item);out.push(item);}
      else{g.groupIds.push(n.id);g.groupCount++;g.read=g.read&&n.read;}
    }
    return out;
  };
  return {loadMoreNotices,groupNoticesForDisplay,
    nK,pushNotice,pushMyNotice,localizeNotice,notif,setNotif,mot,setMot,emailsEnabled,setEmailsEnabled,notices,setNotices,noticesHasMore,setNoticesHasMore,
    noticesSeenAt,setNoticesSeenAt,alerts,setAlerts,rechargerAlertes,noticeFilter,setNoticeFilter,firstRunNotice,setFirstRunNotice};
}
export { useNotifications };
